import { render, staticRenderFns } from "./AttendanceChannel.vue?vue&type=template&id=260b7b36&scoped=true"
import script from "./AttendanceChannel.vue?vue&type=script&lang=js"
export * from "./AttendanceChannel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260b7b36",
  null
  
)

export default component.exports